// English strings (source language): leaderboards.

const en = {
  title: 'Leaderboards',
  friendsIntro: 'Between you and your friends.',
  allIntro: 'Among all players with an account on this server.',
  everyone: 'Everyone',
  friends: 'Friends',
  club: 'Club',
  clubIntro: 'Between the members of your club.',
  emptyClub: 'Nobody in your club is ranked here yet.',
  noClub: 'You are not in a club yet. <a href="#/club">Join or create one</a>',
  tabs: { xp: 'Level', week: 'This week', ghost: 'Time trial', segments: 'Segments' },
  track: 'Track',
  laps: 'Laps',
  segment: 'Segment',
  rider: 'Rider',
  cols: { xp: 'Level', week: 'Distance', ghost: 'Time', segments: 'Time' },
  emptyFriends: 'None of your friends are ranked here yet. <a href="#/friends">Add friends</a>',
  empty: 'Nobody is ranked here yet.',
  offline: 'Server unreachable: leaderboards need the Gruvetto server.',
};
export default en;
